import { render, staticRenderFns } from "./ScreeningDetailPopup.vue?vue&type=template&id=0efcd97e&"
import script from "./ScreeningDetailPopup.vue?vue&type=script&lang=js&"
export * from "./ScreeningDetailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports